<template>
  <button type="button" class="btn-default button" :disabled="disabled" @click="$emit('click')">
    <img :src="icon" alt="sort button">
  </button>
</template>

<script>
import upIcon from '@/assets/icon/sp-sort-button-up.svg'
import upDisabledIcon from '@/assets/icon/sp-sort-button-up-disabled.svg'
import downIcon from '@/assets/icon/sp-sort-button-down.svg'
import downDisabledIcon from '@/assets/icon/sp-sort-button-down-disabled.svg'

export default {
  name: "SortButton",
  props: {
    dir: {
      type: String,
      default: 'up'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      upIcon
    }
  },

  computed: {
    icon() {
      if (this.disabled) {
        if (this.dir === 'up') {
          return upDisabledIcon;
        } else if (this.dir === 'down') {
          return downDisabledIcon;
        }
      } else {
        if (this.dir === 'up') {
          return upIcon;
        } else if (this.dir === 'down') {
          return downIcon;
        }
      }
      return null;
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  color: #525250;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  transition: 0.1s;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  font-size: 13px;
  border-radius: 8px;
  width: 28px;
  height: 24px;
  background-color: #F2F2ED;
  border: 0;
  box-shadow: -2px -2px 4px #fff,
  4px 4px 4px #E6E6E1;

  &:focus,
  &:hover {
    opacity: 0.6;
  }
  &.is-disabled {
    color: #F2F2ED;
    background-color: #F2F2ED;
  }
  &.is-plain:hover {
    background: #fff;
    border-color: #409eff;
    color: #409eff;
    &.is-disabled {
      color: #c0c4cc;
      cursor: not-allowed;
      background-image: none;
      background-color: #fff;
      border-color: #ebeef5;
    }
  }
  & + .my-button {
    margin-left: 20px;
  }
}
</style>

